import { Award, Shield, Layers, Globe, Users } from "lucide-react";

const ITEMS = [
    {
        Icon: Award,
        title: "Premio IFAI 2021",
        desc: "El único reconocimiento internacional para tensoestructuras del país.",
    },
    {
        Icon: Shield,
        title: "Garantía por escrito",
        desc: "Todos nuestros proyectos incluyen garantía formal de fábrica e instalación.",
    },
    {
        Icon: Layers,
        title: "Materiales importados",
        desc: "Dickson, Sioen, Serge Ferrari, Polyfab. Vida útil hasta 30 años.",
    },
    {
        Icon: Globe,
        title: "Cobertura nacional",
        desc: "Instalación en más de 30 ciudades de la República Mexicana.",
    },
    {
        Icon: Users,
        title: "Sin subcontratistas",
        desc: "Fabricamos, confeccionamos e instalamos. Todo con equipo propio.",
    },
];

export default function WhyEclipse() {
    return (
        <section
            data-testid="why-eclipse"
            className="bg-eclipse-light py-20 sm:py-28"
        >
            <div className="container-eclipse">
                <div className="max-w-3xl mb-14">
                    <p className="font-display font-bold text-xs tracking-[0.3em] text-eclipse-cta mb-3">
                        DIFERENCIADORES
                    </p>
                    <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl text-eclipse-primary tracking-tight leading-tight">
                        Por qué elegir Eclipse Cubiertas
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6 lg:gap-4">
                    {ITEMS.map(({ Icon, title, desc }) => (
                        <div
                            key={title}
                            data-testid={`why-card-${title.toLowerCase().replace(/\s/g, "-")}`}
                            className="bg-white p-6 lg:p-7 rounded-sm border border-neutral-200 hover:border-eclipse-cta hover:shadow-lg transition-all group"
                        >
                            <div className="w-12 h-12 rounded-sm bg-eclipse-primary group-hover:bg-eclipse-cta transition-colors flex items-center justify-center mb-5">
                                <Icon
                                    className="w-6 h-6 text-white"
                                    strokeWidth={1.75}
                                />
                            </div>
                            <h3 className="font-display font-bold text-lg text-eclipse-primary mb-2 leading-tight">
                                {title}
                            </h3>
                            <p className="text-sm text-eclipse-muted leading-relaxed">
                                {desc}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
